module.exports = __webpack_public_path__ + "b7548ef57b5750acf6ff3e85b38bd22a.jpg";